<template>
    <div>
        <div class="block-container">
            <div class="swb-back-row">

                <div class="btn-row bg-white" v-if="checkActionPerm('add_work_voucher') && servcOrder != null && !servcOrder.cancelled && shopFlag && comId == shopId">
                    <div class="left-btn fl" @click="addWork">
                        <button class="swb-btn swb-btn-small mr10"><i class="icon iconfont icon-jiahao"></i>新增派工单</button>
                    </div>

                </div>
                <div class="order-search-container">
                    <a class="all-order">全部派工单</a>
                </div>

                <div class="orders-list-container">
                    <table class="orders-list-panel1">
                        <colgroup>
                            <col width="350px">
                            <col width="80px">
                            <col width="220px">
                            <col width="180px">
                            <col width="60px">
                            <col width="200px">
                            <col width="108px">
                        </colgroup>
                        <thead class="orders-header">
                        <tr class="">
                            <th>服务名称</th>
                            <th>金额(元)</th>
                            <th>主工程师</th>
                            <th>预约上门时间</th>
                            <th>紧急状态</th>
                            <th>状态</th>
                            <th>是否评价</th>
                        </tr>
                        </thead>
                        <tbody class="orders-body" v-for="servcWorkVoucher in servcWorkVoucherList">
                        <tr class="blank-row">
                            <td colspan="7"></td>
                        </tr>
                        <tr class="abstract-row">
                            <td colspan="7">
                                <div class="abstract-content">
                                    <span class="mr30">派工单号：
                                        <a class="swb-btn-link" v-if="checkActionPerm('to_work_voucher') && shopFlag" @click="toWorkVoucherPage(servcWorkVoucher.no)">{{servcWorkVoucher.no}}</a>
                                        <span v-else>{{servcWorkVoucher.no}}</span>
                                    </span>
                                    <span class="mr30">买家公司名称：<a>{{servcWorkVoucher.buyerShopName}}</a></span>
                                    <span class="mr30">联系买家：<a>{{servcWorkVoucher.buyerShopContactTel}}</a></span>
                                    <span class="mr30">买家机构地址：<a>{{servcWorkVoucher.buyerShopAddr}}</a></span>
                                </div>
                                <div v-if="servcWorkVoucher.requestProxied" class="table-tips order"></div>
                            </td>
                        </tr>
                        <tr class="info-row">
                            <td>
                                <div class="goods-info-block clearfix">
                                    <div class="good-img">
                                        <img :src="servcWorkVoucher.servcFileBrowseUrl"/>
                                    </div>
                                    <div class="good-msg">
                                        <p class="ellipsis-2 font12">{{servcWorkVoucher.servcTitle}}</p>
                                    </div>
                                </div>
                            </td>
                            <td style="text-align: right;">
                                <span>{{(servcWorkVoucher.amount || 0).toFixed(2)}}</span>
                            </td>
                            <td class="align-left">
                                <div v-if="servcWorkVoucher.servicerEngineer != null" class="clearfix">
                                    <div class="good-img">
                                        <img :src="servcWorkVoucher.servicerEngineer.fileBrowseUrl"/>
                                    </div>
                                    <div class="">
                                        <p class="ellipsis-2 font12">{{servcWorkVoucher.engineerName}}</p>
                                        <p class="ellipsis-2 font12">{{servcWorkVoucher.servicerEngineer.contactTel}}</p>
                                    </div>
                                </div>
                                <div class="clearfix" v-else>
                                    <p class="font12 align-center font-red">待指派工程师</p>
                                </div>
                            </td>
                            <td>
                                <p>
                                    <el-tag v-if="servcWorkVoucher.beyondWrnt" type="danger">交易约定外</el-tag>
                                    <el-tag type="success" v-else>交易约定内</el-tag>
                                </p>
                                <p class="font-gray1">{{servcWorkVoucher.planTime}}</p>
                            </td>
                            <td>
                                <p v-if="servcWorkVoucher.emgLevel == 0" class="font-green">{{ emgLevelMap[servcWorkVoucher.emgLevel] }}</p>
                                <p v-if="servcWorkVoucher.emgLevel == 1" class="font-orange">{{ emgLevelMap[servcWorkVoucher.emgLevel] }}</p>
                                <p v-if="servcWorkVoucher.emgLevel == 2" class="font-red">{{ emgLevelMap[servcWorkVoucher.emgLevel] }}</p>
                            </td>
                            <td>
                                <p v-if="servcWorkVoucher.invalid" class="font-red">已作废</p>
                                <p v-else-if="servcWorkVoucher.closed" class="font-red">已关闭</p>
                                <p v-else-if="!servcWorkVoucher.invalid">{{servcWorkVoucher.stateText}}</p>
                                <p v-if="servcWorkVoucher.stateText == '服务暂停'" class="font-red">原因：{{servcWorkVoucher.stateDesc}}</p>
                                <p v-if="servcWorkVoucher.stateText == '已拒接'" class="font-red">拒接原因：{{servcWorkVoucher.refuseCause}}</p>
                                <a class="swb-btn-link" v-if="checkActionPerm('view_charge_item')" @click="toChargeItems(servcWorkVoucher.id)">查看收费项</a>
                                <a class="swb-btn-link" @click="toWorkVoucherDetail(servcWorkVoucher.id)">查看详情</a>
                            </td>
                            <td>
                                <p v-if="servcWorkVoucher.evalFlag" class="font-green">已评价</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { checkUserActionPerm } from '../index'
    import { openWorkVoucherDetailDlg } from './showDetailDlg'

    import userApi from '../../api/user'
    import servcDelivApi from '../../api/servcDeliv'
    import servcOrderApi from '../../api/servcOrder'

    // 订单收费项
    import SwbServcOrderChargeItemList from './ServcOrderChargeItemList';
    Vue.regist(SwbServcOrderChargeItemList);

    import SwbServcWorkVoucherList from './ServcWorkVoucherList';
    Vue.regist(SwbServcWorkVoucherList);

    export default {
        name: 'swb-servc-work-voucher-of-order',
        desc: '派工单列表(服务订单详情使用)',
        props: ['orderId', 'shopId', 'selfPath'],
        data: function () {
            return {
                servcOrder: null,
                servcWorkVoucherList: [],
                emgLevelMap: getEnumMap('emgLevel', 'value2text'),
                shopFlag: false,
                comId: false
            }
        },
        created: function () {
            this.getServOrder();
            this.getCurrentUserInfo();
            this.getServcWorkVoucherList();
        },
        methods: {
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(this.selfPath, action, targetPostId);
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == "info") {
                        self.shopFlag = result.data.scopeEntity.shopFlag;
                        self.comId = result.data.scopeEntity.comId;
                    }
                })
            },
            getServOrder: function () {
                let self = this;
                let id = self.orderId;
                let loading = MsgBox.loading();
                servcOrderApi.getServcOrderInfo(id, function (result) {
                    if(result.type == "info") {
                        let servcOrder = result.data;
                        self.servcOrder = servcOrder;
                        loading.close();
                    } else {
                        loading.close();
                        MsgBox.warning(result.message);
                    }
                });
            },
            getServcWorkVoucherList: function () {
                let self = this;
                let postData = {};
                postData.orderId = self.orderId;
                servcDelivApi.getServcWorkVoucherListByOrderId(postData, function (result) {
                    if(result.type == 'info') {
                        let servcWorkVoucherList = result.data;
                        if(!Utils.isNoB(servcWorkVoucherList) && servcWorkVoucherList.length > 0) {
                            for(let i = 0; i < servcWorkVoucherList.length; i++) {
                                let servcWorkVoucher = servcWorkVoucherList[i];
                                let stateInfo = getEnumInfoWith('workAssignState', 'value', servcWorkVoucher.state);
                                servcWorkVoucher.stateText = stateInfo.text;
                            }
                        }
                        self.servcWorkVoucherList = servcWorkVoucherList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 查看收费项
            toChargeItems: function (workId) {
                Vue.$showDialog({
                    title: '工单 - 查看收费项',
                    showCloseBtn: true,
                    cancelText: '关闭',
                    okVisible: false,
                    width: 600,
                    height: 420,
                    template: '<div>' +
                    '<swb-servc-order-charge-item-list :workId="workId" ref="swb_servc_order_charge_item_list"></swb-servc-order-charge-item-list>' +
                    '</div>',
                    data: {
                        workId: workId,
                    },
                    methods: {},
                    okClicked: function () {
                    },
                    lifecycle: {
                        created: function () {
                        }
                    }
                });
            },
            // 跳转到派工单列表(门店才有该操作)
            toWorkVoucherPage: function (no) {
                this.$router.push({
                    query: {no: no},
                    path: SwbServcWorkVoucherList.path,
                });
            },
            addWork: function () {
                let addWork = 2;
                this.$emit("action-chang", addWork)
            },
            // 工单详情
            toWorkVoucherDetail: function (id) {
                openWorkVoucherDetailDlg(id);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherOfOrder.vue